import { render } from "./ArchivePrinting.vue?vue&type=template&id=3142763a&scoped=true"
import script from "./ArchivePrinting.vue?vue&type=script&lang=js"
export * from "./ArchivePrinting.vue?vue&type=script&lang=js"

import "./ArchivePrinting.vue?vue&type=style&index=0&id=3142763a&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3142763a"]])

export default __exports__